module.exports = __webpack_public_path__ + "img/1280x720-Futurism.6335d212.jpg";